interface TimeoutRef {
  timeoutId: number;
  delay: number;
  callback: () => void;
}

const setRecursiveTimeoutInternal = (timeoutRef: TimeoutRef): TimeoutRef => {
  // eslint-disable-next-line no-param-reassign
  timeoutRef.timeoutId = window.setTimeout(() => {
    try {
      timeoutRef.callback();
    } catch (err: unknown) {
      // eslint-disable-next-line no-console
      console.error(err);
    }

    // it's important that setRecursiveTimeout() runs _after_ the callback so
    // that the callback has an opportunity to clear it before it runs again.
    setRecursiveTimeoutInternal(timeoutRef);
  }, timeoutRef.delay);
  return timeoutRef;
};

/**
 * setRecursiveTimeout() behaves like setInterval(), except using recursive
 * setTimeout() calls, which avoids total CPU saturation in the event of
 * long-running callbacks.
 *
 * @param callback the function to call
 * @param delay the delay in milliseconds between calls
 * @returns a TimeoutRef that can be passed to clearRecursiveTimeout(). You can
 * also change the delay of a recursive timeout like timeoutRef.delay = 1000;
 */
export const setRecursiveTimeout = (callback: () => void, delay = 0): TimeoutRef => {
  return setRecursiveTimeoutInternal({ timeoutId: -1, delay, callback });
};

/**
 * Clears a recursive timeout.
 * @param timeoutRef the TimeoutRef returned by setRecursiveTimeout()
 */
export const clearRecursiveTimeout = (timeoutRef: TimeoutRef): void => {
  clearTimeout(timeoutRef.timeoutId);
};
